'use client'
import { memo, type MouseEvent, type FC } from 'react'
import Image from 'next/image'
import styled from 'styled-components'
import { useDeviceType } from '@/hooks'
import type { TypeMedia, TypeVideoExternal } from '@/schema'
import { E_MEDIA_TYPES } from '@/utils'

type TypeFigure = {
  readonly media: TypeMedia | TypeVideoExternal,
  readonly lazy?: boolean,
  readonly initialInView?: boolean,
  onClick?: (e: MouseEvent<HTMLElement>) => void,
  readonly fill?: boolean,
  readonly outRef?: (node?: Element) => void,
  readonly className?: string,
  readonly sizes?: string,
  readonly quality?: number
  readonly ariaHidden?: boolean
  readonly unoptimized?: boolean
}

const FigureStyled = styled.figure`
  display: block;
  position: relative;

  img {
    object-fit: cover;
    transition: all 300ms linear;
  }
`

export const Figure: FC<TypeFigure> = memo<TypeFigure>(({ media, lazy = true, fill = true, onClick = null, className = '', outRef = null, sizes = '70vw', quality = 75, ariaHidden = false, unoptimized = false}) => {
  const { isMobile } = useDeviceType()
  if (!media) return <figure className='placeholder' />
  if (media.type === 'video') return <></>
  // if(media.type === 'video') return <Video data={media} />

  return (
    <FigureStyled className={className} {...onClick && { onClick }}  {...outRef && { ref: outRef }}>
      {media.type === E_MEDIA_TYPES.svg ?
        <Image src={media.src} alt={media.alt} fill={fill} aria-hidden={ariaHidden}
          {...!lazy && { priority: true }}
          {...!fill && { height: media.size!.height }}
          {...!fill && { width: media.size!.width }}
          unoptimized={true}
        />
        :
        <Image
          // placeholder='blur'
          src={media?.[(isMobile && media?.mobile) ? 'mobile' : 'default']?.src} alt={media?.alt} fill={fill}
          {...!lazy && { priority: true }}
          {...!fill && { height: media?.[(isMobile && media?.mobile) ? 'mobile' : 'default'].size.height }}
          {...!fill && { width: media?.[(isMobile && media?.mobile) ? 'mobile' : 'default'].size.width }}
          sizes={sizes}
          {...quality !== 75 && { quality }}
          {...unoptimized && { unoptimized: true }}
        />
      }
    </FigureStyled>
  )
})
